import { useState } from "react";
import journeyrewardobject from "../../assets/images/journeyrewardobject2.png";
import journeyrewardbg from "../../assets/images/journeyrewardbg2.png";
import FirebaseService from "../../core/services/firebase.service";
import journeyrewardobject2 from "../../assets/images/journeyrewardobject22.png"
import { useRedeemJourney } from "../../core/services/journey.service";
import FirebaseKey from "../FirebaseKey/FirebaseKey";
interface RewardPopupProps {
  rewardAmount: number; // in MB, will be converted to GB
  catalogTempId: string;
  deeplink: string;
  onClose?: () => void;
}

type ButtonState = "idle" | "loading" | "success" | "redirect";
type LaterButtonState = "idle" | "later_note" | "redirect";

const RewardPopup = ({
  rewardAmount,
  catalogTempId,
  deeplink,
  onClose,
}: RewardPopupProps) => {
  const rewardInGB = rewardAmount / 1000;
  const [buttonState, setButtonState] = useState<ButtonState>("idle");
  const [laterButtonState, setLaterButtonState] = useState<LaterButtonState>("idle");
  const [countdown, setCountdown] = useState(5);
  const [laterCountdown, setLaterCountdown] = useState(5);
  const redeemJourney = useRedeemJourney();

  const handleNowClick = async () => {
    try {
      setButtonState("loading");
      await redeemJourney.mutateAsync(catalogTempId);

      // Success state
      setButtonState("success");

      // After 2 seconds, show redirect countdown
      setTimeout(() => {
        setButtonState("redirect");
        setCountdown(5);

        // Start countdown
        const countdownInterval = setInterval(() => {
          setCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(countdownInterval);
              // Redirect to deeplink
              window.location.href = deeplink;
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      }, 2000);
    } catch (error) {
      console.error("Error redeeming journey:", error);
      setButtonState("idle");
    }
  };

  const handleLaterClick = () => {
    // Show later note first
    setLaterButtonState("later_note");

    // After showing the note, transition to redirect countdown
    setTimeout(() => {
      setLaterButtonState("redirect");
      setLaterCountdown(5);

      // Start countdown
      const countdownInterval = setInterval(() => {
        setLaterCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            // Redirect to deeplink
            window.location.href = deeplink;
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }, 2000); // Show later_note for 2 seconds before countdown
  };

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/70"
        onClick={onClose}
      />

      {/* Popup Content */}
      <div className="relative bg-gradient-to-b rounded-[36px] max-w-[320px] shadow-2xl max-w-md w-full overflow-hidden z-10 border-[0.5px] border-white/20" style={{ backgroundImage: `url(${journeyrewardbg})`, backgroundSize: 'cover', backgroundPosition: 'center -20px' }}>
        {/* Gradient overlay */}
        {/* <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black pointer-events-none rounded-[36px]" /> */}
        <div className="flex flex-col items-center text-center relative z-10">
          {/* Visual Header Area - Placeholder for image */}
          <div className="w-full relative overflow-hidden">
            {/* Placeholder for chest image - user will add this */}
            <div className="w-full h-full grid grid-cols-1 grid-rows-1 justify-items-center items-center justify-center p-2 gap-2">
              {/* <svg width="280" height="241" className="col-span-full row-span-full w-full h-full" viewBox="0 0 280 241" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g style={{ mixBlendMode: 'plus-lighter' }}>
                  <circle cx="140" cy="-23.2418" r="132" stroke="url(#paint0_radial_5651_5638)" stroke-opacity="0.2" stroke-width="263.758" stroke-linejoin="round" stroke-dasharray="60 60" />
                </g>
                <defs>
                  <radialGradient id="paint0_radial_5651_5638" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(140 -23.2418) rotate(90) scale(263.879)">
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </radialGradient>
                </defs>
              </svg> */}

              <img src={journeyrewardobject2} alt="kazan" className="w-32 object-contain col-span-full h-8" />

              <img src={journeyrewardobject} alt="chest" className="w-36 object-contain col-span-full" />
            </div>
          </div>

          {/* Main Content */}
          <div className="px-2 py-2 w-full flex flex-col items-center">
            {/* Title */}
            <h2 className="text-base font-bold text-white">
              <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_title} />
            </h2>

            {/* Description */}
            <p className="text-sm text-white/90 mb-4">
              <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_desc} />
            </p>

            {/* Reward Section */}
            <div className="w-full bg-[rgba(120,119,118,0.20)] border-[0.5px] border-[rgba(255,255,255,0.20)] rounded-[20px] backdrop-blur-[5px] px-4 py-4 flex flex-col items-center mb-2">
              <p className="text-xs font-medium text-white/80">
                <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_reward_title} />
              </p>
              <p className="text-[40px] font-medium text-white">
                {rewardInGB} GB
              </p>
            </div>

            {/* Next Level Note */}
            <p className="text-xs text-white/80 mb-2">
              <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_next_level_note} />
            </p>

            {/* Action Buttons */}
            <div className="w-full flex flex-col gap-2">
              {/* Primary Button */}
              <button
                onClick={handleNowClick}
                disabled={buttonState === "loading" || buttonState === "success" || buttonState === "redirect" || laterButtonState !== "idle"}
                className="w-full bg-[#0088FF] text-white rounded-full py-4 px-6 font-normal text-base hover:bg-[#0088FF]/90 transition-colors disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {buttonState === "loading" && (
                  <>
                    <svg
                      className="animate-spin text-white"
                      width="24" height="24"
                      viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 6V2M12 18V22M6 12H2M18 12H22M16 16L19 19M8 16L5 19M8 8L5 5M16 8L19 5" stroke="#434242" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_now_loading_note} />
                  </>
                )}
                {buttonState === "success" && (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.6667 5L7.50004 14.1667L3.33337 10"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_now_note} />
                  </>
                )}
                {buttonState === "redirect" && (
                  <>
                    <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_redirect_note} /> {countdown}
                  </>
                )}
                {buttonState === "idle" && (
                  <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_now_button} />
                )}
              </button>

              {/* Secondary Button */}
              <button
                onClick={handleLaterClick}
                disabled={buttonState === "loading" || buttonState === "success" || buttonState === "redirect" || laterButtonState !== "idle"}
                className="w-full bg-white/80 shadow-sm text-black rounded-full py-4 px-4 font-normal text-base transition-colors disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {laterButtonState === "later_note" && (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.6667 5L7.50004 14.1667L3.33337 10"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_later_note} />
                  </>
                )}
                {laterButtonState === "redirect" && (
                  <>
                    <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_redirect_note} /> {laterCountdown}
                  </>
                )}
                {laterButtonState === "idle" && (
                  <>

                    <FirebaseKey firebaseKey={FirebaseService.journey_milestone_congrats_later_button} />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardPopup;
